'use client'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import useScreenWidth from '@/hooks/useScreenWidth'
import { useRouter } from 'next/navigation'
const Template02 = (props: any) => {
  const screenWidth = useScreenWidth()
  const router = useRouter()

  const Navigate = (link: string, type: any) => {
    if (type === 'external_link') {
      window.open(link, '_blank')
    } else {
      router.push(link)
    }
  }

  return (
    <>
      {props.data !== undefined && (
        <section className="shopby-category-section">
          <div className="container-fluid1 px-0">
            <div className="main-title-section text-center">
              <h2 className="main-title-heading">{props.data.name}</h2>
            </div>
            <div className="shopby-category-slider">
              <Swiper
                effect="fade"
                slidesPerView={5}
                modules={[Navigation, Autoplay]}
                navigation={true}
                loop={true}
                autoplay={{
                  delay: 1500
                }}
                centeredSlides={true}
                speed={800}
                spaceBetween={0}
                breakpoints={{
                  300: {
                    slidesPerView: 1
                  },
                  768: {
                    slidesPerView: 3
                  },
                  991: {
                    slidesPerView: 3
                  },
                  1025: {
                    slidesPerView: 4
                  },
                  1200: {
                    slidesPerView: 4
                  },
                  1300: {
                    slidesPerView: 5
                  }
                }}
              >
                {props.data.section_items.map((item: any, itemIndex: number) => (
                  <SwiperSlide key={itemIndex}>
                    <div className="category-slider-repeat">
                      <span
                        onClick={(e) => Navigate(item.link, item.type)}
                        className="category-slider-img"
                      >
                        <img
                          src={screenWidth > 768 ? item.desktop_image : item.mobile_image}
                          alt="product"
                          loading="lazy"
                        />
                      </span>
                      <div className="category-slider-content">
                        <span
                          onClick={(e) => Navigate(item.link, item.type)}
                          className="category-slider-title"
                        >
                          <h3 className="category-slider-name">{item.title}</h3>
                          {/* <p>{Common.capitalizeString(item.description)}</p> */}
                        </span>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
                {/* {props.data.section_items.map((item, itemIndex) => (
                  <SwiperSlide key={itemIndex}>
                    <div className="category-slider-repeat">
                      <span
                        onClick={(e) => Navigate(item.link, item.type)}
                        className="category-slider-img"
                      >
                        <img
                          src={ScreenWidth > 768 ? item.desktop_image : item.mobile_image}
                          alt="product"
                        />
                      </span>
                      <div className="category-slider-content">
                        <span
                          onClick={(e) => Navigate(item.link, item.type)}
                          className="category-slider-title"
                        >
                          <h3 className="category-slider-name">{item.title}</h3>
                        </span>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))} */}
              </Swiper>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default Template02
